import angular from 'angular';
import {accessLevels} from '../services/accessLevels';
import 'angular-breadcrumb';
import 'ng-table';

import './ad/adControllers';
import './banners/bannersControllers';
import './categories/categoriesControllers';
import './chats/chatsControllers';
import './competitions/competitionsControllers';
import './coupons/couponsControllers';
import './dishes/dishesControllers';
import './evaluations/evaluationsControllers';
import './exhibitors/exhibitorsControllers';
import './facets/facetsControllers';
import './files/filesControllers';
import './forms/formsControllers';
import './galleries/galleriesControllers';
import './games/gamesControllers';
import './gamifications/gamificationsControllers';
import './groups/groupsControllers';
import './levelrebuses/levelRebusesControllers';
import './levels/levelsControllers';
import './libraries/librariesControllers';
import './logs/logsControllers';
import './maps/mapsControllers';
import './meetings/meetingsControllers';
import './menu/menuControllers';
import './news/newsControllers';
import './newspapers/newspapersControllers';
import './notes/notesControllers';
import './order/userOrderControllers';
import './polls/pollsControllers';
import './posts/postsControllers';
import './price_lists/priceListsControllers';
import './products/productsControllers';
import './promotions/promotionsControllers';
import './rebuses/rebusesControllers';
import './recipes/recipesControllers';
import './reviews/reviewsControllers';
import './sections/sectionsControllers';
import './shopping_lists/shoppingListsControllers';
import './shops/shopsControllers';
import './shortcodes/shortCodesControllers';
import './sso/ssoControllers';
import './themes/themesControllers';
import './integrations/userIntegrationsControllers';
import './messages/userMessagesControllers';
import './users/appUsersControllers';
import './users/appUsersServices';
import './users-www/appUsersWebControllers';
import './webelements/webElementsControllers';
import './webpages/webPagesControllers';
import './websections/webSectionsControllers';
import './exhibitors/workers/workersControllers';


const ApplicationController = ['$rootScope', '$stateParams', function ($rootScope, $stateParams) {
    'use strict';
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
}];

angular.module('applicationModule', [
    'applicationModule.appUsersWebControllers',
    'applicationModule.webPagesControllers',
    'applicationModule.webElementsControllers',
    'applicationModule.webSectionsControllers',
    'applicationModule.librariesControllers',
    'applicationModule.facetsControllers',
    'applicationModule.dishesControllers',
    'applicationModule.pollsControllers',
    'applicationModule.bannersControllers',
    'applicationModule.sectionsControllers',
    'applicationModule.newsControllers',
    'applicationModule.priceListsControllers',
    'applicationModule.chatsControllers',
    'applicationModule.exhibitorsControllers',
    'applicationModule.formsControllers',
    'applicationModule.galleriesControllers',
    'applicationModule.newspapersControllers',
    'applicationModule.filesControllers',
    'applicationModule.appUsersServices',
    'applicationModule.recipesControllers',
    'applicationModule.userOrderControllers',
    'applicationModule.adControllers',
    'applicationModule.appUsersControllers',
    'applicationModule.categoriesControllers',
    'applicationModule.competitionsControllers',
    'applicationModule.couponsControllers',
    'applicationModule.evaluationsControllers',
    'applicationModule.gamesControllers',
    'applicationModule.gamificationsControllers',
    'applicationModule.groupsControllers',
    'applicationModule.levelRebusesControllers',
    'applicationModule.levelsControllers',
    'applicationModule.logsControllers',
    'applicationModule.mapsControllers',
    'applicationModule.meetingsControllers',
    'applicationModule.menuControllers',
    'applicationModule.notesControllers',
    'applicationModule.postsControllers',
    'applicationModule.productsControllers',
    'applicationModule.promotionsControllers',
    'applicationModule.rebusesControllers',
    'applicationModule.reviewsControllers',
    'applicationModule.shoppingListsControllers',
    'applicationModule.shopsControllers',
    'applicationModule.shortCodesControllers',
    'applicationModule.ssoControllers',
    'applicationModule.themesControllers',
    'applicationModule.userIntegrationsControllers',
    'applicationModule.userMessagesControllers',
    'applicationModule.workersControllers',
    'ncy-angular-breadcrumb',
    'ngTable'
])
    .config(['$stateProvider', function ($stateProvider) {
        'use strict';
        $stateProvider
            .state('appsoup.application', {
                url: '/application/:application_id',
                ncyBreadcrumb: {
                    label: 'MODULES.APPLICATION.TITLE'
                },
                controller: ApplicationController,
                template: '<ui-view/><div module-box></div>'
            })
            .state('appsoup.application.sections', {
                url: '/sections',
                templateUrl: 'views/application/sections/sections.tpl.html',
                controller: 'SectionsListController',
                ncyBreadcrumb: {
                    label: 'MODULES.SECTIONS.TITLE'
                },
                accessLevel: accessLevels.section
            })
            .state('appsoup.application.section', {
                url: '/section/:section_id',
                templateUrl: 'views/application/sections/section.tpl.html',
                controller: 'SectionPageController',
                ncyBreadcrumb: {
                    label: '{{section.name}}',
                    parent: 'appsoup.application.sections'
                },
                menuActive: 'appsoup.application.sections',
                accessLevel: accessLevels.section
            })
            .state('appsoup.application.users', {
                url: '/users',
                templateUrl: 'views/application/users/users.tpl.html',
                controller: 'AppUsersListController',
                ncyBreadcrumb: {
                    label: 'MODULES.APPLICATIONS.MODULES.USERS.TITLES.MAIN'
                },
                accessLevel: accessLevels.users
            })
            .state('appsoup.application.userEdit', {
                url: '/user/:userId/edit',
                templateUrl: 'views/application/users/user.tpl.html',
                controller: 'AppUserController',
                ncyBreadcrumb: {
                    label: 'MODULES.APPLICATIONS.MODULES.USERS.TITLES.EDIT',
                    parent: 'appsoup.application.users'
                },
                menuActive: 'appsoup.application.users',
                accessLevel: accessLevels.users
            })
            .state('appsoup.application.userCreate', {
                url: '/user/create',
                templateUrl: 'views/application/users/user.tpl.html',
                controller: 'AppUserController',
                ncyBreadcrumb: {
                    label: 'MODULES.APPLICATIONS.MODULES.USERS.TITLES.NEW',
                    parent: 'appsoup.application.users'
                },
                menuActive: 'appsoup.application.users',
                accessLevel: accessLevels.users
            })
            .state('appsoup.application.userDevice', {
                url: '/users/:userId',
                templateUrl: 'views/application/users/userDevice.tpl.html',
                controller: 'AppUserDeviceController',
                ncyBreadcrumb: {
                    label: 'MODULES.APPLICATIONS.MODULES.USERS.TITLES.DEVICES',
                    parent: 'appsoup.application.users'
                },
                menuActive: 'appsoup.application.users',
                accessLevel: accessLevels.users
            })
            .state('appsoup.application.userDetail', {
                url: '/users/:userId/:type',
                templateUrl: 'views/application/users/userDetail.tpl.html',
                controller: 'AppUserDetailController',
                ncyBreadcrumb: {
                    label: '{{pageTitle}}',
                    parent: 'appsoup.application.users'
                },
                menuActive: 'appsoup.application.users',
                accessLevel: accessLevels.users
            })
            .state('appsoup.application.messages', {
                url: '/messages',
                templateUrl: 'views/application/messages/index.tpl.html',
                controller: 'UserMessagesController',
                ncyBreadcrumb: {
                    label: 'MODULES.MESSAGES.TITLE'
                },
                accessLevel: accessLevels.messages
            })
            .state('appsoup.application.newMessage', {
                url: '/messages/send',
                templateUrl: 'views/application/messages/messages.tpl.html',
                controller: 'UserMessagesSendController',
                ncyBreadcrumb: {
                    label: 'MODULES.MESSAGES.NEW',
                    parent: 'appsoup.application.messages'
                },
                menuActive: 'appsoup.application.messages',
                accessLevel: accessLevels.messages
            })
            .state('appsoup.application.products', {
                url: '/products',
                templateUrl: 'views/application/products/products.tpl.html',
                controller: 'ProductsListController',
                params: {
                    searchProduct: null
                },
                ncyBreadcrumb: {
                    label: 'MODULES.PRODUCTS.TITLE'
                },
                accessLevel: accessLevels.products
            })
            .state('appsoup.application.newProduct', {
                url: '/products/new',
                controller: 'ProductPageController',
                templateUrl: 'views/application/products/product.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.PRODUCTS.NEW_PRODUCT',
                    parent: 'appsoup.application.products'
                },
                menuActive: 'appsoup.application.products',
                accessLevel: accessLevels.products
            })
            .state('appsoup.application.importProducts', {
                url: '/products/import',
                controller: 'ProductImportController',
                templateUrl: 'views/application/products/import.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.PRODUCTS.IMPORT_PRODUCTS',
                    parent: 'appsoup.application.products'
                },
                menuActive: 'appsoup.application.products',
                accessLevel: accessLevels.products
            })
            .state('appsoup.application.editProduct', {
                url: '/products/:productId',
                controller: 'ProductPageController',
                templateUrl: 'views/application/products/product.tpl.html',
                params: {
                    searchProduct: null
                },
                ncyBreadcrumb: {
                    label: 'MODULES.PRODUCTS.EDIT_PRODUCT',
                    parent: 'appsoup.application.products'
                },
                menuActive: 'appsoup.application.products',
                accessLevel: accessLevels.products
            })
            .state('appsoup.application.productGallery', {
                url: '/products/:productId/gallery',
                controller: 'ProductGalleryController',
                templateUrl: 'views/application/products/gallery.tpl.html',
                params: {
                    searchGalleries: null
                },
                ncyBreadcrumb: {
                    label: 'MODULES.GALLERY.TITLE',
                    parent: 'appsoup.application.products'
                },
                menuActive: 'appsoup.application.products',
                accessLevel: accessLevels.products
            })
            .state('appsoup.application.reviews', {
                url: '/reviews',
                controller: 'ReviewsListController',
                templateUrl: 'views/application/reviews/reviews.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.REVIEWS.TITLE'
                },
                accessLevel: accessLevels.reviews
            })
            .state('appsoup.application.abuse', {
                url: '/reviews/:reviewId',
                controller: 'AbuseListController',
                templateUrl: 'views/application/reviews/abuse.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.REVIEWS.ABUSE',
                    parent: 'appsoup.application.reviews'
                },
                accessLevel: accessLevels.reviews
            })
            .state('appsoup.application.order', {
                url: '/order',
                templateUrl: 'views/application/order/order.tpl.html',
                controller: 'OrderListController',
                ncyBreadcrumb: {
                    label: 'MODULES.ORDER.TITLE'
                },
                accessLevel: accessLevels.orders
            })
            .state('appsoup.application.orderDetail', {
                url: '/order/:orderId',
                templateUrl: 'views/application/order/orderDetail.tpl.html',
                controller: 'OrderDetailController',
                ncyBreadcrumb: {
                    label: 'MODULES.ORDER.TITLE'
                },
                accessLevel: accessLevels.orders
            })
            .state('appsoup.application.sectionModule', {
                url: '/section/:section_id/module/:order_id',
                templateUrl: 'views/application/sections/section.module.tpl.html',
                controller: 'SectionModulePageController',
                ncyBreadcrumb: {
                    label: '{{module.name}}',
                    parent: 'appsoup.application.section'
                },
                menuActive: 'appsoup.application.sections',
                accessLevel: accessLevels.section
            })
            .state('appsoup.application.sectionModuleElement', {
                url: '/section/:section_id/module/:order_id/element/:element_id',
                templateUrl: 'views/application/sections/section.module.edit.tpl.html',
                controller: 'SectionModuleElementPageController',
                ncyBreadcrumb: {
                    label: '{{module_element.name}}',
                    parent: 'appsoup.application.sectionModule'
                },
                menuActive: 'appsoup.application.sections',
                accessLevel: accessLevels.section
            })
            .state('appsoup.application.menu', {
                url: '/menu',
                templateUrl: 'views/application/menu/menu.list.tpl.html',
                controller: 'MenuListController',
                ncyBreadcrumb: {
                    label: 'MODULES.MENU.TITLE'
                },
                accessLevel: accessLevels.menu
            })
            .state('appsoup.application.menuEdit', {
                url: '/menu/:menu_id',
                templateUrl: 'views/application/menu/menuEdit.tpl.html',
                controller: 'MenuPageController',
                ncyBreadcrumb: {
                    label: '{{menu.name}}',
                    parent: 'appsoup.application.menu'
                },
                accessLevel: accessLevels.menu
            })
            .state('appsoup.application.shops', {
                url: '/shop',
                templateUrl: 'views/application/shops/shops.tpl.html',
                controller: 'ShopsController',
                ncyBreadcrumb: {
                    label: 'MENU.SHOPS'
                },
                accessLevel: accessLevels.shops
            })
            .state('appsoup.application.shopNew', {
                url: '/shop/new',
                templateUrl: 'views/application/shops/shop.tpl.html',
                controller: 'ShopController',
                ncyBreadcrumb: {
                    label: 'MODULES.SHOP.NEW_SHOP',
                    parent: 'appsoup.application.shops'
                },
                menuActive: 'appsoup.application.shops',
                accessLevel: accessLevels.shops
            })
            .state('appsoup.application.editShop', {
                url: '/shop/:shopId',
                controller: 'ShopController',
                templateUrl: 'views/application/shops/shop.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.SHOP.EDIT_SHOP',
                    parent: 'appsoup.application.shops'
                },
                menuActive: 'appsoup.application.shops',
                accessLevel: accessLevels.shops
            })
            .state('appsoup.application.exhibitors', {
                url: '/exhibitors',
                templateUrl: 'views/application/exhibitors/exhibitors.tpl.html',
                controller: 'ExhibitorsListController',
                ncyBreadcrumb: {
                    label: 'MENU.EXHIBITORS'
                },
                accessLevel: accessLevels.exhibitors
            })
            .state('appsoup.application.exhibitor', {
                url: '/exhibitor/:exhibitorId',
                templateUrl: 'views/application/exhibitors/exhibitor.tpl.html',
                controller: 'ExhibitorPageController',
                ncyBreadcrumb: {
                    label: 'MODULES.EXHIBITORS.HEADING.EXHIBITOR.EDIT',
                    parent: 'appsoup.application.exhibitors'
                },
                menuActive: 'appsoup.application.exhibitors',
                accessLevel: accessLevels.exhibitors
            })
            .state('appsoup.application.workers', {
                url: '/exhibitor/:exhibitorId/workers',
                templateUrl: 'views/application/exhibitors/workers/workers.tpl.html',
                controller: 'WorkersController',
                ncyBreadcrumb: {
                    label: 'MODULES.EXHIBITORS.HEADING.WORKERS.TABLE',
                    parent: 'appsoup.application.exhibitors'
                },
                menuActive: 'appsoup.application.exhibitors',
                accessLevel: accessLevels.exhibitors
            })
            .state('appsoup.application.new_worker', {
                url: '/exhibitor/:exhibitorId/new',
                templateUrl: 'views/application/exhibitors/workers/worker.tpl.html',
                controller: 'WorkerEditController',
                ncyBreadcrumb: {
                    label: 'MODULES.EXHIBITORS.HEADING.WORKERS.TABLE',
                    parent: 'appsoup.application.exhibitors'
                },
                menuActive: 'appsoup.application.exhibitors',
                accessLevel: accessLevels.exhibitors
            })
            .state('appsoup.application.workerEdit', {
                url: '/exhibitor/workers/:workerId/:exhibitorId',
                templateUrl: 'views/application/exhibitors/workers/worker.tpl.html',
                controller: 'WorkerEditController',
                ncyBreadcrumb: {
                    label: 'MODULES.EXHIBITORS.HEADING.WORKERS.TABLE',
                    parent: 'appsoup.application.exhibitors'
                },
                menuActive: 'appsoup.application.exhibitors',
                accessLevel: accessLevels.exhibitors
            })
            .state('appsoup.application.newExhibitor', {
                url: '/exhibitor',
                templateUrl: 'views/application/exhibitors/exhibitor.tpl.html',
                controller: 'ExhibitorPageController',
                ncyBreadcrumb: {
                    label: 'MODULES.EXHIBITORS.HEADING.EXHIBITOR.NEW',
                    parent: 'appsoup.application.exhibitors'
                },
                menuActive: 'appsoup.application.exhibitors',
                accessLevel: accessLevels.exhibitors
            })
            .state('appsoup.application.updateNews', {
                url: '/news-tags/update/:tag',
                controller: 'NewsUpdateTagsController',
                templateUrl: 'views/application/news/news-update-tag.tpl.html',
                params: {
                    searchNews: null
                },
                ncyBreadcrumb: {
                    label: 'MODULES.NEWS.TITLE_TAGS'
                },
                accessLevel: accessLevels.news
            })
            .state('appsoup.application.news', {
                url: '/news',
                controller: 'NewsListController',
                templateUrl: 'views/application/news/news-list.tpl.html',
                params: {
                    searchNews: null
                },
                ncyBreadcrumb: {
                    label: 'MODULES.NEWS.TITLE'
                },
                accessLevel: accessLevels.news
            })
            .state('appsoup.application.newNews', {
                url: '/news/new',
                controller: 'NewsPageController',
                templateUrl: 'views/application/news/news.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.NEWS.NEW_NEWS',
                    parent: 'appsoup.application.news'
                },
                menuActive: 'appsoup.application.news',
                accessLevel: accessLevels.news
            })
            .state('appsoup.application.editNews', {
                url: '/news/:newsId',
                controller: 'NewsPageController',
                templateUrl: 'views/application/news/news.tpl.html',
                params: {
                    searchNews: null
                },
                ncyBreadcrumb: {
                    label: 'MODULES.NEWS.EDIT_NEWS',
                    parent: 'appsoup.application.news'
                },
                menuActive: 'appsoup.application.news',
                accessLevel: accessLevels.news
            })
            .state('appsoup.application.competitions', {
                url: '/competitions',
                controller: 'CompetitionsListController',
                templateUrl: 'views/application/competitions/competitions.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.COMPETITION.TITLE'
                },
                accessLevel: accessLevels.competitions
            })
            .state('appsoup.application.newCompetition', {
                url: '/competitions/new',
                controller: 'CompetitionPageController',
                templateUrl: 'views/application/competitions/competition.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.COMPETITION.NEW_COMPETITION',
                    parent: 'appsoup.application.competitions'
                },
                menuActive: 'appsoup.application.competitions',
                accessLevel: accessLevels.competitions
            })
            .state('appsoup.application.editCompetition', {
                url: '/competitions/:competitionId',
                controller: 'CompetitionPageController',
                templateUrl: 'views/application/competitions/competition.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.COMPETITION.EDIT_COMPETITION',
                    parent: 'appsoup.application.competitions'
                },
                menuActive: 'appsoup.application.competitions',
                accessLevel: accessLevels.competitions
            })
            .state('appsoup.application.games', {
                url: '/games',
                controller: 'GamesListController',
                templateUrl: 'views/application/games/games.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.GAMES.TITLE'
                },
                accessLevel: accessLevels.games
            })
            .state('appsoup.application.newGame', {
                url: '/game/new',
                controller: 'GamePageController',
                templateUrl: 'views/application/games/game.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.GAMES.NEW_GAME',
                    parent: 'appsoup.application.games'
                },
                menuActive: 'appsoup.application.games',
                accessLevel: accessLevels.games
            })
            .state('appsoup.application.editGame', {
                url: '/game/:gameId',
                controller: 'GamePageController',
                templateUrl: 'views/application/games/game.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.GAMES.EDIT_GAME',
                    parent: 'appsoup.application.games'
                },
                menuActive: 'appsoup.application.games',
                accessLevel: accessLevels.games
            })
            .state('appsoup.application.gamesPoint', {
                url: '/game/points/:gameId',
                controller: 'GamesPointsController',
                templateUrl: 'views/application/games/points.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.GAMES.GAMES_POINTS',
                    parent: 'appsoup.application.games'
                },
                menuActive: 'appsoup.application.games',
                accessLevel: accessLevels.games
            })
            .state('appsoup.application.maps', {
                url: '/map',
                controller: 'MapController',
                templateUrl: 'views/application/maps/index.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.MAPS.TITLE'
                },
                accessLevel: accessLevels.maps
            })
            .state('appsoup.application.levels', {
                url: '/levels',
                controller: 'LevelsListController',
                templateUrl: 'views/application/levels/levels.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.LEVELS.TITLE'
                },
                accessLevel: accessLevels.levels
            })
            .state('appsoup.application.newLevel', {
                url: '/level/new',
                controller: 'LevelPageController',
                templateUrl: 'views/application/levels/level.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.LEVELS.NEW_LEVEL',
                    parent: 'appsoup.application.levels'
                },
                menuActive: 'appsoup.application.levels',
                accessLevel: accessLevels.levels
            })
            .state('appsoup.application.editLevel', {
                url: '/level/:levelId',
                controller: 'LevelPageController',
                templateUrl: 'views/application/levels/level.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.LEVELS.EDIT_LEVEL',
                    parent: 'appsoup.application.levels'
                },
                menuActive: 'appsoup.application.levels',
                accessLevel: accessLevels.levels
            })
            .state('appsoup.application.levelBeacons', {
                url: '/level/beacons/:levelId',
                controller: 'LevelBeaconsController',
                templateUrl: 'views/application/levels/beacons.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.LEVELS.LEVEL_BEACONS',
                    parent: 'appsoup.application.levels'
                },
                menuActive: 'appsoup.application.levels',
                accessLevel: accessLevels.levels
            })
            .state('appsoup.application.dishes', {
                url: '/dishes/?:dishesType',
                controller: 'DishesProvidersController',
                templateUrl: 'views/application/dishes/index.tpl.html',
                ncyBreadcrumb: {
                    label: '{{dishesTypeLabel}}'
                },
                menuActive: 'appsoup.application.dishes',
                accessLevel: accessLevels.dishes
            })
            .state('appsoup.application.newProvider', {
                url: '/provider',
                templateUrl: 'views/application/dishes/providers/edit.tpl.html',
                controller: 'ProviderPageController',
                ncyBreadcrumb: {
                    label: 'MODULES.APPLICATIONS.MODULES.DISHES.TITLES.NEW_PROVIDER',
                    parent: 'appsoup.application.dishes({dishesType: "exhibitors"})'
                },
                menuActive: 'appsoup.application.dishes',
                accessLevel: accessLevels.dishes
            })
            .state('appsoup.application.provider', {
                url: '/provider/:exhibitorId',
                templateUrl: 'views/application/dishes/providers/edit.tpl.html',
                controller: 'ProviderPageController',
                ncyBreadcrumb: {
                    label: 'MODULES.APPLICATIONS.MODULES.DISHES.TITLES.EDIT_PROVIDER',
                    parent: 'appsoup.application.dishes({dishesType: "exhibitors"})'
                },
                menuActive: 'appsoup.application.dishes',
                accessLevel: accessLevels.dishes
            })
            .state('appsoup.application.newDish', {
                url: '/dish/new',
                controller: 'EditDishController',
                templateUrl: 'views/application/dishes/dishes/edit.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.APPLICATIONS.MODULES.DISHES.TITLES.NEW',
                    parent: 'appsoup.application.dishes({dishesType: "dishes"})'
                },
                menuActive: 'appsoup.application.dishes',
                accessLevel: accessLevels.dishes
            })
            .state('appsoup.application.dish', {
                url: '/dish/:dish_id',
                controller: 'EditDishController',
                templateUrl: 'views/application/dishes/dishes/edit.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.APPLICATIONS.MODULES.DISHES.TITLES.EDIT',
                    parent: 'appsoup.application.dishes({dishesType: "dishes"})'
                },
                menuActive: 'appsoup.application.dishes',
                accessLevel: accessLevels.dishes
            })
            .state('appsoup.application.userDishOrders', {
                url: '/dishes-orders/:userId',
                controller: 'AppUserDishOrdersController',
                templateUrl: 'views/application/users/dish_orders/index.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.APPLICATIONS.MODULES.DISHES.TITLES.ORDERS',
                    parent: 'appsoup.application.users'
                },
                menuActive: 'appsoup.application.users',
                accessLevel: accessLevels.dishes
            })
            .state('appsoup.application.usersActivity', {
                url: '/activities',
                controller: 'AppUsersActivityController',
                templateUrl: 'views/application/users/activities/index.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.APPLICATIONS.MODULES.ACTIVITIES.TITLE',
                    parent: 'appsoup.application.users'
                },
                menuActive: 'appsoup.application.users',
                accessLevel: accessLevels.levels
            })
            .state('appsoup.application.userBadges', {
                url: '/badges/:userId',
                controller: 'AppUserBadgesController',
                templateUrl: 'views/application/users/badges/index.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.APPLICATIONS.MODULES.GAMIFICATIONS.BADGES.TITLE',
                    parent: 'appsoup.application.users'
                },
                menuActive: 'appsoup.application.users',
                accessLevel: accessLevels.gamifications
            })
            .state('appsoup.application.userDishOrders.date', {
                url: '/:date',
                controller: 'AppUserDishOrdersDateController',
                templateUrl: 'views/application/users/dish_orders/date.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.APPLICATIONS.MODULES.DISHES.TITLES.DETAILS',
                    parent: 'appsoup.application.userDishOrders'
                },
                menuActive: 'appsoup.application.users',
                accessLevel: accessLevels.dishes
            })
            .state('appsoup.application.notes', {
                url: '/notes',
                controller: 'NotesController',
                templateUrl: 'views/application/notes/notes.tpl.html',
                params: {
                    searchNotes: null
                },
                ncyBreadcrumb: {
                    label: 'MODULES.NOTES.NOTES'
                },
                accessLevel: accessLevels.notes
            })
            .state('appsoup.application.noteCreate', {
                url: '/notes/create',
                controller: 'CreateNotesController',
                templateUrl: 'views/application/notes/note.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.NOTES.CREATE_NOTES',
                    parent: 'appsoup.application.notes'
                },
                menuActive: 'appsoup.application.notes',
                accessLevel: accessLevels.notes
            })
            .state('appsoup.application.editNote', {
                url: '/notes/edit/:noteId',
                controller: 'CreateNotesController',
                templateUrl: 'views/application/notes/note.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.NOTES.EDIT_NOTE',
                    parent: 'appsoup.application.notes'
                },
                menuActive: 'appsoup.application.notes',
                accessLevel: accessLevels.notes
            })
            .state('appsoup.application.ads', {
                url: '/announcement',
                controller: 'AdController',
                templateUrl: 'views/application/ad/ads.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.AD.AD'
                },
                accessLevel: accessLevels.ads
            })
            .state('appsoup.application.adCreate', {
                url: '/announcement/create',
                controller: 'CreateAdController',
                templateUrl: 'views/application/ad/ad.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.AD.TITLES.NEW',
                    parent: 'appsoup.application.ads'
                },
                menuActive: 'appsoup.application.ads',
                accessLevel: accessLevels.ads
            })
            .state('appsoup.application.editAd', {
                url: '/announcement/edit/:adId',
                controller: 'CreateAdController',
                templateUrl: 'views/application/ad/ad.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.AD.TITLES.EDIT',
                    parent: 'appsoup.application.ads'
                },
                menuActive: 'appsoup.application.ads',
                accessLevel: accessLevels.ads
            })
            // Meetings
            .state('appsoup.application.meetings', {
                url: '/meetings',
                controller: 'MeetingsListController',
                templateUrl: 'views/application/meetings/meetings.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.MEETINGS.TITLE'
                },
                accessLevel: accessLevels.meetings
            })
            .state('appsoup.application.newMeeting', {
                url: '/meeting/new',
                controller: 'MeetingPageController',
                templateUrl: 'views/application/meetings/meeting.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.MEETINGS.NEW_MEETING',
                    parent: 'appsoup.application.meetings'
                },
                menuActive: 'appsoup.application.meetings',
                accessLevel: accessLevels.meetings
            })
            .state('appsoup.application.editMeeting', {
                url: '/meeting/:meetingId',
                controller: 'MeetingPageController',
                templateUrl: 'views/application/meetings/meeting.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.MEETINGS.EDIT_MEETING',
                    parent: 'appsoup.application.meetings'
                },
                menuActive: 'appsoup.application.meetings',
                accessLevel: accessLevels.meetings
            })
            // Gamifications
            .state('appsoup.application.gamifications', {
                url: '/gamifications',
                controller: 'GamificationsIndexController',
                templateUrl: 'views/application/gamifications/index.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.APPLICATIONS.MODULES.GAMIFICATIONS.TITLE'
                },
                accessLevel: accessLevels.gamifications
            })
            .state('appsoup.application.gamifications.actions', {
                url: '/actions',
                controller: 'GamificationsActionsListController',
                templateUrl: 'views/application/gamifications/actions/index.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.APPLICATIONS.MODULES.GAMIFICATIONS.ACTIONS.TITLE',
                    parent: 'appsoup.application.gamifications'
                },
                menuActive: 'appsoup.application.gamifications',
                accessLevel: accessLevels.gamifications
            })
            .state('appsoup.application.newAction', {
                url: '/action/new',
                controller: 'GamificationsActionPageController',
                templateUrl: 'views/application/gamifications/actions/edit.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.APPLICATIONS.MODULES.GAMIFICATIONS.ACTIONS.NEW',
                    parent: 'appsoup.application.gamifications'
                },
                menuActive: 'appsoup.application.gamifications',
                accessLevel: accessLevels.gamifications
            })
            .state('appsoup.application.editAction', {
                url: '/action/:actionId',
                controller: 'GamificationsActionPageController',
                templateUrl: 'views/application/gamifications/actions/edit.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.APPLICATIONS.MODULES.GAMIFICATIONS.ACTIONS.EDIT',
                    parent: 'appsoup.application.gamifications'
                },
                menuActive: 'appsoup.application.gamifications',
                accessLevel: accessLevels.gamifications
            })
            .state('appsoup.application.gamifications.badges', {
                url: '/badges',
                controller: 'GamificationsBadgesListController',
                templateUrl: 'views/application/gamifications/badges/index.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.APPLICATIONS.MODULES.GAMIFICATIONS.BADGES.TITLE',
                    parent: 'appsoup.application.gamifications'
                },
                menuActive: 'appsoup.application.gamifications',
                accessLevel: accessLevels.gamifications
            })
            .state('appsoup.application.newGamificationsBadge', {
                url: '/gamifications-badge/new',
                controller: 'GamificationsBadgePageController',
                templateUrl: 'views/application/gamifications/badges/edit.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.APPLICATIONS.MODULES.GAMIFICATIONS.BADGES.NEW',
                    parent: 'appsoup.application.gamifications'
                },
                menuActive: 'appsoup.application.gamifications',
                accessLevel: accessLevels.gamifications
            })
            .state('appsoup.application.editGamificationsBadge', {
                url: '/gamifications-badge/:badgeId',
                controller: 'GamificationsBadgePageController',
                templateUrl: 'views/application/gamifications/badges/edit.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.APPLICATIONS.MODULES.GAMIFICATIONS.BADGES.EDIT',
                    parent: 'appsoup.application.gamifications'
                },
                menuActive: 'appsoup.application.gamifications',
                accessLevel: accessLevels.gamifications
            })
            .state('appsoup.application.chats', {
                url: '/chats',
                controller: 'ChatsListController',
                templateUrl: 'views/application/chats/index.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.APPLICATIONS.MODULES.CHATS.TITLE'
                },
                accessLevel: accessLevels.chats
            })
            .state('appsoup.application.newChat', {
                url: '/chat/new',
                controller: 'ChatPageController',
                templateUrl: 'views/application/chats/edit.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.APPLICATIONS.MODULES.CHATS.NEW_CHAT',
                    parent: 'appsoup.application.chats'
                },
                menuActive: 'appsoup.application.chats',
                accessLevel: accessLevels.chats
            })
            .state('appsoup.application.editChat', {
                url: '/chat/:chatId',
                controller: 'ChatPageController',
                templateUrl: 'views/application/chats/edit.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.APPLICATIONS.MODULES.CHATS.EDIT_CHAT',
                    parent: 'appsoup.application.chats'
                },
                menuActive: 'appsoup.application.chats',
                accessLevel: accessLevels.chats
            })
            .state('appsoup.application.chatUsers', {
                url: '/chat/:chatId/users',
                controller: 'ChatUsersController',
                templateUrl: 'views/application/chats/users/index.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.APPLICATIONS.MODULES.CHATS.USERS',
                    parent: 'appsoup.application.chats'
                },
                menuActive: 'appsoup.application.chats',
                accessLevel: accessLevels.chats
            })
            .state('appsoup.application.posts', {
                url: '/posts',
                controller: 'PostsController',
                templateUrl: 'views/application/posts/index.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.APPLICATIONS.MODULES.POSTS.TITLE'
                },
                accessLevel: accessLevels.posts
            })
            .state('appsoup.application.newPost', {
                url: '/post',
                controller: 'PostController',
                templateUrl: 'views/application/posts/edit.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.APPLICATIONS.MODULES.POSTS.NEW',
                    parent: 'appsoup.application.posts'
                },
                menuActive: 'appsoup.application.posts',
                accessLevel: accessLevels.posts
            })
            .state('appsoup.application.editPost', {
                url: '/post/:post_id',
                controller: 'PostController',
                templateUrl: 'views/application/posts/edit.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.APPLICATIONS.MODULES.POSTS.EDIT',
                    parent: 'appsoup.application.posts'
                },
                menuActive: 'appsoup.application.posts',
                accessLevel: accessLevels.posts
            })
            .state('appsoup.application.webpages', {
                url: '/webpages/?:page_id',
                controller: 'WebpagesController',
                templateUrl: 'views/application/web/pages/index.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.APPLICATIONS.MODULES.WWW.PAGES.EDIT'
                },
                accessLevel: accessLevels.cms_www
            })
            .state('appsoup.application.webelements', {
                url: '/webpages/:page_id/module/:module_id',
                controller: 'WebelementsController',
                templateUrl: 'views/application/web/elements/index.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.APPLICATIONS.MODULES.WWW.ELEMENTS.TITLE',
                    parent: 'appsoup.application.webpages'
                },
                accessLevel: accessLevels.cms_www
            })
            .state('appsoup.application.webSectionNew', {
                url: '/webpages/:page_id/section/:container',
                controller: 'WebSectionController',
                templateUrl: 'views/application/web/sections/section.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.APPLICATIONS.MODULES.WWW.SECTION.TITLE.NEW',
                    parent: 'appsoup.application.webpages'
                },
                accessLevel: accessLevels.cms_www
            })
            .state('appsoup.application.webSectionEdit', {
                url: '/webpages/:page_id/section/:container/:section_id',
                controller: 'WebSectionController',
                templateUrl: 'views/application/web/sections/section.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.APPLICATIONS.MODULES.WWW.SECTION.TITLE.EDIT',
                    parent: 'appsoup.application.webpages'
                },
                accessLevel: accessLevels.cms_www
            })
            .state('appsoup.application.import_actions_data', {
                url: '/webpages/:page_id/module/:module_id/import',
                controller: 'ImportActionsDataController',
                templateUrl: 'views/application/users/import/import.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.ACTIONS.IMPORT_DATA',
                    parent: 'appsoup.application.webpages'
                },
                accessLevel: accessLevels.cms_www
            })
            .state('appsoup.application.delete_actions_data', {
                url: '/webpages/:page_id/module/:module_id/delete',
                controller: 'DeleteActionsDataController',
                templateUrl: 'views/application/users/delete/delete.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.ACTIONS.DELETE_DATA',
                    parent: 'appsoup.application.webpages'
                },
                accessLevel: accessLevels.cms_www
            })
            .state('appsoup.application.webpagePreview', {
                url: '/webpages/:page_id/preview/:type',
                controller: 'WebpagePreviewController',
                templateUrl: 'views/application/web/pages/show.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.APPLICATIONS.MODULES.WWW.PAGES.PREVIEW',
                    parent: 'appsoup.application.webpages'
                },
                accessLevel: accessLevels.cms_www
            })
            .state('appsoup.application.webpagesHistory', {
                url: '/webpages/:page_id/history',
                controller: 'WebpageHistoryController',
                templateUrl: 'views/application/web/pages/history.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.APPLICATIONS.MODULES.WWW.PAGES.HISTORY',
                    parent: 'appsoup.application.webpages'
                },
                accessLevel: accessLevels.cms_www
            })
            .state('appsoup.application.webpagesVersions', {
                url: '/webpages/:page_id/versions',
                controller: 'WebpageVersionsController',
                templateUrl: 'views/application/web/pages/versions.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.APPLICATIONS.MODULES.WWW.PAGES.COLOR_VERSIONS',
                    parent: 'appsoup.application.webpages'
                },
                accessLevel: accessLevels.cms_www
            })
            .state('appsoup.application.webpagesHeaders', {
                url: '/webpages/page/headers',
                controller: 'WebpageHeadersController',
                templateUrl: 'views/application/web/pages/headers.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.APPLICATIONS.MODULES.WWW.PAGES.HEADERS',
                    parent: 'appsoup.application.webpages'
                },
                accessLevel: accessLevels.cms_www
            })
            .state('appsoup.application.webpagesHeadersElements', {
                url: '/webpages/page/headers/:headerId/elements',
                controller: 'WebpageHeadersElementsController',
                templateUrl: 'views/application/web/pages/headerElements.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.APPLICATIONS.MODULES.WWW.PAGES.ELEMENTS',
                    parent: 'appsoup.application.webpages'
                },
                accessLevel: accessLevels.cms_www
            })
            .state('appsoup.application.webpagesFooters', {
                url: '/webpages/page/footers',
                controller: 'WebpageFootersController',
                templateUrl: 'views/application/web/pages/footers.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.APPLICATIONS.MODULES.WWW.PAGES.FOOTERS',
                    parent: 'appsoup.application.webpages'
                },
                accessLevel: accessLevels.cms_www
            })
            .state('appsoup.application.webpagesActions', {
                url: '/webpages/page/web-actions',
                controller: 'WebpageActionsController',
                templateUrl: 'views/application/web/pages/web-actions.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.APPLICATIONS.MODULES.WWW.PAGES.WEB_ACTIONS',
                    parent: 'appsoup.application.webpages'
                },
                accessLevel: accessLevels.cms_www
            })
            .state('appsoup.application.webpagesFootersElements', {
                url: '/webpages/page/footers/:footerId/elements',
                controller: 'WebpageFootersElementsController',
                templateUrl: 'views/application/web/pages/footerElements.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.APPLICATIONS.MODULES.WWW.PAGES.ELEMENTS',
                    parent: 'appsoup.application.webpagesFooters'
                },
                accessLevel: accessLevels.cms_www
            })
            .state('appsoup.application.webpagesSidebars', {
                url: '/webpages/page/sidebars',
                controller: 'WebpageSidebarsController',
                templateUrl: 'views/application/web/pages/sidebars.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.APPLICATIONS.MODULES.WWW.PAGES.SIDEBARS',
                    parent: 'appsoup.application.webpages'
                },
                accessLevel: accessLevels.cms_www
            })
            .state('appsoup.application.webpagesSidebarsElements', {
                url: '/webpages/page/sidebars/:sidebarId/elements',
                controller: 'WebpageSidebarsElementsController',
                templateUrl: 'views/application/web/pages/sidebarElements.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.APPLICATIONS.MODULES.WWW.PAGES.ELEMENTS',
                    parent: 'appsoup.application.webpagesSidebars'
                },
                accessLevel: accessLevels.cms_www
            })
            .state('appsoup.application.groups', {
                url: '/groups',
                controller: 'GroupsController',
                templateUrl: 'views/application/groups/groups.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.GROUPS.TITLE'
                },
                accessLevel: accessLevels.groups
            })
            .state('appsoup.application.newGroup', {
                url: '/group/new',
                controller: 'GroupController',
                templateUrl: 'views/application/groups/group.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.GROUPS.NEW_GROUP',
                    parent: 'appsoup.application.groups'
                },
                menuActive: 'appsoup.application.groups',
                accessLevel: accessLevels.groups
            })
            .state('appsoup.application.editGroup', {
                url: '/group/:groupId',
                controller: 'GroupController',
                templateUrl: 'views/application/groups/group.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.GROUPS.EDIT_GROUP',
                    parent: 'appsoup.application.groups'
                },
                menuActive: 'appsoup.application.groups',
                accessLevel: accessLevels.groups
            })
            .state('appsoup.application.groupUsersList', {
                url: '/group/:groupId/users',
                controller: 'GroupListController',
                templateUrl: 'views/application/groups/usersList.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.GROUPS.USERS_LIST',
                    parent: 'appsoup.application.groups'
                },
                menuActive: 'appsoup.application.groups',
                accessLevel: accessLevels.groups
            })
            .state('appsoup.application.files', {
                url: '/files',
                controller: 'FilesController',
                templateUrl: 'views/application/files/files.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.FILES.TITLE'
                },
                accessLevel: accessLevels.files
            })
            .state('appsoup.application.sso', {
                url: '/sso',
                controller: 'SSOController',
                templateUrl: 'views/application/sso/sso.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.SSO.TITLE'
                },
                accessLevel: accessLevels.sso
            })
            .state('appsoup.application.libraries', {
                url: '/libraries',
                controller: 'LibrariesController',
                controllerAs: 'vm',
                templateUrl: 'views/application/libraries/libraries.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.LIBRARIES.TITLE'
                },
                accessLevel: accessLevels.libraries
            })
            .state('appsoup.application.librariesCrop', {
                url: '/libraries/crop',
                controller: 'LibrariesCropController',
                controllerAs: 'vm',
                templateUrl: 'views/application/libraries/crop.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.LIBRARIES.CROPPER.TITLE'
                },
                accessLevel: accessLevels.libraries
            })
            .state('appsoup.application.galleries', {
                url: '/galleries',
                controller: 'GalleriesController',
                templateUrl: 'views/application/galleries/galleries.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.GALLERIES.TITLE'
                },
                accessLevel: accessLevels.galleries
            })
            .state('appsoup.application.galleryElements', {
                url: '/galleries/:galleryId/elements',
                controller: 'GalleryElementsController',
                templateUrl: 'views/application/galleries/elements.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.GALLERIES.ELEMENTS.TITLE',
                    parent: 'appsoup.application.galleries'
                },
                menuActive: 'appsoup.application.galleries',
                accessLevel: accessLevels.galleries
            })
            .state('appsoup.application.banners', {
                url: '/banners',
                controller: 'BannersController',
                templateUrl: 'views/application/banners/banners.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.BANNERS.TITLE'
                },
                params: {
                    searchBanners: null
                },
                accessLevel: accessLevels.banners
            })
            .state('appsoup.application.bannerElements', {
                url: '/banners/:bannerId/elements',
                controller: 'BannerElementsController',
                templateUrl: 'views/application/banners/elements.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.BANNERS.ELEMENTS.TITLE',
                    parent: 'appsoup.application.banners'
                },
                menuActive: 'appsoup.application.banners',
                accessLevel: accessLevels.banners
            })
            .state('appsoup.application.forms', {
                url: '/forms',
                controller: 'FormsController',
                templateUrl: 'views/application/forms/forms.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.FORMS.TITLE'
                },
                accessLevel: accessLevels.forms
            })
            .state('appsoup.application.formElements', {
                url: '/forms/:formId/elements',
                controller: 'FormElementsController',
                templateUrl: 'views/application/forms/elements.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.FORMS.ELEMENTS.TITLE',
                    parent: 'appsoup.application.forms'
                },
                menuActive: 'appsoup.application.forms',
                accessLevel: accessLevels.forms
            })
            .state('appsoup.application.polls', {
                url: '/polls',
                controller: 'PollsController',
                templateUrl: 'views/application/polls/polls.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.POLLS.TITLE'
                },
                accessLevel: accessLevels.polls
            })
            .state('appsoup.application.pollElements', {
                url: '/poll/:pollId/elements',
                controller: 'PollElementsController',
                templateUrl: 'views/application/polls/elements/elements.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.POLLS.ELEMENTS.TITLE',
                    parent: 'appsoup.application.polls'
                },
                menuActive: 'appsoup.application.polls',
                accessLevel: accessLevels.polls
            })
            .state('appsoup.application.pollOptions', {
                url: '/poll/:pollId/element/:elementId/options',
                controller: 'PollElementOptionsController',
                templateUrl: 'views/application/polls/elements/options/options.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.POLLS.ELEMENTS.OPTIONS.TITLE',
                    parent: 'appsoup.application.pollElements'
                },
                menuActive: 'appsoup.application.polls',
                accessLevel: accessLevels.polls
            })
            .state('appsoup.application.pollResults', {
                url: '/poll/:pollId/results',
                controller: 'PollResultsController',
                templateUrl: 'views/application/polls/results/results.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.POLLS.RESULTS.TITLE',
                    parent: 'appsoup.application.polls'
                },
                menuActive: 'appsoup.application.polls',
                accessLevel: accessLevels.polls
            })
            .state('appsoup.application.recipes', {
                url: '/recipes',
                controller: 'RecipesController',
                templateUrl: 'views/application/recipes/recipes.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.RECIPES.TITLES.RECIPES.MAIN'
                },
                params: {
                    searchRecipe: null,
                    page: 1
                },
                menuActive: 'appsoup.application.recipes',
                accessLevel: accessLevels.recipes
            })
            .state('appsoup.application.newRecipe', {
                url: '/recipes/new',
                controller: 'RecipeController',
                templateUrl: 'views/application/recipes/recipe.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.RECIPES.TITLES.RECIPES.NEW',
                    parent: 'appsoup.application.recipes'
                },
                params: {
                    searchRecipe: null,
                    page: 1
                },
                menuActive: 'appsoup.application.recipes',
                accessLevel: accessLevels.recipes
            })
            .state('appsoup.application.editRecipe', {
                url: '/recipes/:recipeId/edit',
                controller: 'RecipeController',
                templateUrl: 'views/application/recipes/recipe.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.RECIPES.TITLES.RECIPES.EDIT',
                    parent: 'appsoup.application.recipes'
                },
                params: {
                    searchRecipe: null,
                    page: 1
                },
                menuActive: 'appsoup.application.recipes',
                accessLevel: accessLevels.recipes
            })
            .state('appsoup.application.recipes_posts_import', {
                url: '/recipes/import',
                controller: 'RecipePostsImportController',
                templateUrl: 'views/application/recipes/import.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.RECIPES.TITLES.RECIPES.IMPORT_POSTS',
                    parent: 'appsoup.application.recipes'
                },
                accessLevel: accessLevels.recipes
            })
            .state('appsoup.application.ingredients', {
                url: '/recipes/:recipeId/ingredients',
                controller: 'RecipeIngredientsController',
                templateUrl: 'views/application/recipes/ingredients/ingredients.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.RECIPES.TITLES.INGREDIENTS.MAIN',
                    parent: 'appsoup.application.recipes'
                },
                menuActive: 'appsoup.application.recipes',
                accessLevel: accessLevels.recipes
            })
            .state('appsoup.application.newIngredient', {
                url: '/recipes/:recipeId/ingredients/new',
                controller: 'RecipeIngredientController',
                templateUrl: 'views/application/recipes/ingredients/ingredient.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.RECIPES.TITLES.INGREDIENTS.NEW',
                    parent: 'appsoup.application.ingredients'
                },
                menuActive: 'appsoup.application.recipes',
                accessLevel: accessLevels.recipes
            })
            .state('appsoup.application.editIngredient', {
                url: '/recipes/:recipeId/ingredients/:ingredientId/edit',
                controller: 'RecipeIngredientController',
                templateUrl: 'views/application/recipes/ingredients/ingredient.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.RECIPES.TITLES.INGREDIENTS.EDIT',
                    parent: 'appsoup.application.ingredients'
                },
                menuActive: 'appsoup.application.recipes',
                accessLevel: accessLevels.recipes
            })
            .state('appsoup.application.editMassiveIngredient', {
                url: '/recipes/:recipeId/ingredients/massive-edit',
                controller: 'RecipeIngredientsEditController',
                templateUrl: 'views/application/recipes/ingredients/massive_edit.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.RECIPES.TITLES.INGREDIENTS.MASSIVE_EDIT',
                    parent: 'appsoup.application.ingredients'
                },
                menuActive: 'appsoup.application.recipes',
                accessLevel: accessLevels.recipes
            })
            .state('appsoup.application.preparations', {
                url: '/recipes/:recipeId/preparations',
                controller: 'RecipePreparationsController',
                templateUrl: 'views/application/recipes/preparations/preparations.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.RECIPES.TITLES.PREPARATIONS.MAIN',
                    parent: 'appsoup.application.recipes'
                },
                menuActive: 'appsoup.application.recipes',
                accessLevel: accessLevels.recipes
            })
            .state('appsoup.application.newPreparation', {
                url: '/recipes/:recipeId/preparations/new',
                controller: 'RecipePreparationController',
                templateUrl: 'views/application/recipes/preparations/preparation.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.RECIPES.TITLES.PREPARATIONS.NEW',
                    parent: 'appsoup.application.preparations'
                },
                menuActive: 'appsoup.application.recipes',
                accessLevel: accessLevels.recipes
            })
            .state('appsoup.application.editPreparation', {
                url: '/recipes/:recipeId/preparations/:preparationId/edit',
                controller: 'RecipePreparationController',
                templateUrl: 'views/application/recipes/preparations/preparation.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.RECIPES.TITLES.PREPARATIONS.EDIT',
                    parent: 'appsoup.application.preparations'
                },
                menuActive: 'appsoup.application.recipes',
                accessLevel: accessLevels.recipes
            })
            .state('appsoup.application.recipeAllIngredients', {
                url: '/recipes/all-ingredients',
                controller: 'RecipeAllIngredientsController',
                templateUrl: 'views/application/recipes/all-ingredients/allIngredients.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.RECIPES.TITLES.ALL_INGREDIENTS.MAIN',
                    parent: 'appsoup.application.recipes'
                },
                menuActive: 'appsoup.application.recipes',
                accessLevel: accessLevels.recipes
            })
            .state('appsoup.application.recipeAuthors', {
                url: '/recipes/authors',
                controller: 'RecipeAuthorsController',
                templateUrl: 'views/application/recipes/recipe-authors/authors.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.RECIPES.TITLES.AUTHORS.MAIN',
                    parent: 'appsoup.application.recipes'
                },
                menuActive: 'appsoup.application.recipes',
                accessLevel: accessLevels.recipes
            })
            .state('appsoup.application.newRecipeAuthor', {
                url: '/recipes/authors/new',
                controller: 'RecipeAuthorController',
                templateUrl: 'views/application/recipes/recipe-authors/author.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.RECIPES.TITLES.AUTHORS.NEW',
                    parent: 'appsoup.application.recipeAuthors'
                },
                menuActive: 'appsoup.application.recipes',
                accessLevel: accessLevels.recipes
            })
            .state('appsoup.application.editRecipeAuthor', {
                url: '/recipes/authors/:authorId/edit',
                controller: 'RecipeAuthorController',
                templateUrl: 'views/application/recipes/recipe-authors/author.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.RECIPES.TITLES.AUTHORS.EDIT',
                    parent: 'appsoup.application.recipeAuthors'
                },
                menuActive: 'appsoup.application.recipes',
                accessLevel: accessLevels.recipes
            })
            .state('appsoup.application.recipesTags', {
                url: '/recipes/tags',
                controller: 'RecipesTagsController',
                templateUrl: 'views/application/recipes/recipes-tags/tags.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.RECIPES.TITLES.TAGS.MAIN',
                    parent: 'appsoup.application.recipes'
                },
                menuActive: 'appsoup.application.recipes',
                accessLevel: accessLevels.recipes
            })
            .state('appsoup.application.newRecipesTag', {
                url: '/recipes/tags/new',
                controller: 'RecipesTagController',
                templateUrl: 'views/application/recipes/recipes-tags/tag.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.RECIPES.TITLES.TAGS.NEW',
                    parent: 'appsoup.application.recipesTags'
                },
                menuActive: 'appsoup.application.recipes',
                accessLevel: accessLevels.recipes
            })
            .state('appsoup.application.editRecipesTag', {
                url: '/recipes/tags/:tagId/edit',
                controller: 'RecipesTagController',
                templateUrl: 'views/application/recipes/recipes-tags/tag.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.RECIPES.TITLES.TAGS.EDIT',
                    parent: 'appsoup.application.recipesTags'
                },
                menuActive: 'appsoup.application.recipes',
                accessLevel: accessLevels.recipes
            })
            .state('appsoup.application.promotions', {
                url: '/promotions',
                controller: 'PromotionsController',
                templateUrl: 'views/application/promotions/promotions.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.PROMOTIONS.TITLES.MAIN'
                },
                menuActive: 'appsoup.application.promotions',
                accessLevel: accessLevels.promotions
            })
            .state('appsoup.application.newPromotion', {
                url: '/promotions/new',
                controller: 'PromotionController',
                templateUrl: 'views/application/promotions/promotion.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.PROMOTIONS.TITLES.NEW',
                    parent: 'appsoup.application.promotions'
                },
                menuActive: 'appsoup.application.promotions',
                accessLevel: accessLevels.promotions
            })
            .state('appsoup.application.editPromotion', {
                url: '/promotions/:promotionId/edit',
                controller: 'PromotionController',
                templateUrl: 'views/application/promotions/promotion.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.PROMOTIONS.TITLES.EDIT',
                    parent: 'appsoup.application.promotions'
                },
                menuActive: 'appsoup.application.promotions',
                accessLevel: accessLevels.promotions
            })
            .state('appsoup.application.importPromotions', {
                url: '/promotions/import',
                controller: 'PromotionImportController',
                templateUrl: 'views/application/promotions/import.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.PROMOTIONS.TITLES.IMPORT',
                    parent: 'appsoup.application.promotions'
                },
                menuActive: 'appsoup.application.promotions',
                accessLevel: accessLevels.promotions
            })
            .state('appsoup.application.newspapers', {
                url: '/newspapers',
                controller: 'NewspapersController',
                templateUrl: 'views/application/newspapers/newspapers.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.NEWSPAPERS.TITLES.MAIN'
                },
                menuActive: 'appsoup.application.newspapers',
                accessLevel: accessLevels.newspapers
            })
            .state('appsoup.application.newNewspaper', {
                url: '/newspapers/new',
                controller: 'NewspaperController',
                templateUrl: 'views/application/newspapers/newspaper.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.NEWSPAPERS.TITLES.NEW',
                    parent: 'appsoup.application.newspapers'
                },
                menuActive: 'appsoup.application.newspapers',
                accessLevel: accessLevels.newspapers
            })
            .state('appsoup.application.editNewspaper', {
                url: '/newspapers/:newspaperId/edit',
                controller: 'NewspaperController',
                templateUrl: 'views/application/newspapers/newspaper.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.NEWSPAPERS.TITLES.EDIT',
                    parent: 'appsoup.application.newspapers'
                },
                menuActive: 'appsoup.application.newspapers',
                accessLevel: accessLevels.newspapers
            })
            .state('appsoup.application.importShops', {
                url: '/newspapers/import-shops/:newspaperId',
                controller: 'NewspaperImportShopController',
                templateUrl: 'views/application/newspapers/import_shops/import_shops.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.NEWSPAPERS.IMPORT_SHOPS.TITLE',
                    parent: 'appsoup.application.newspapers'
                },
                menuActive: 'appsoup.application.newspapers',
                accessLevel: accessLevels.newspapers
            })
            .state('appsoup.application.newspaperPages', {
                url: '/newspapers/:newspaperId/pages',
                controller: 'NewspaperPagesController',
                templateUrl: 'views/application/newspapers/pages/pages.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.NEWSPAPERS.PAGES.TITLES.MAIN',
                    parent: 'appsoup.application.newspapers'
                },
                menuActive: 'appsoup.application.newspapers',
                accessLevel: accessLevels.newspapers
            })
            .state('appsoup.application.newNewspaperPage', {
                url: '/newspapers/:newspaperId/pages/new',
                controller: 'NewspaperPageController',
                templateUrl: 'views/application/newspapers/pages/page.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.NEWSPAPERS.PAGES.TITLES.NEW',
                    parent: 'appsoup.application.newspaperPages'
                },
                menuActive: 'appsoup.application.newspapers',
                accessLevel: accessLevels.newspapers
            })
            .state('appsoup.application.editNewspaperPage', {
                url: '/newspapers/:newspaperId/pages/:newspaperPageId/edit',
                controller: 'NewspaperPageController',
                templateUrl: 'views/application/newspapers/pages/page.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.NEWSPAPERS.PAGES.TITLES.EDIT',
                    parent: 'appsoup.application.newspaperPages'
                },
                menuActive: 'appsoup.application.newspapers',
                accessLevel: accessLevels.newspapers
            })
            .state('appsoup.application.evaluations', {
                url: '/evaluations',
                controller: 'EvaluationsController',
                templateUrl: 'views/application/evaluations/evaluations.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.EVALUATIONS.TITLE'
                },
                accessLevel: accessLevels.evaluations
            })
            .state('appsoup.application.level_rebuses', {
                url: '/level-rebuses',
                controller: 'LevelRebusesController',
                templateUrl: 'views/application/levelrebuses/levelRebuses.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.LEVEL_REBUSES.TITLE'
                },
                accessLevel: accessLevels.level_rebuses
            })
            .state('appsoup.application.rebuses', {
                url: '/rebuses',
                controller: 'RebusesController',
                templateUrl: 'views/application/rebuses/rebuses.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.REBUSES.TITLE'
                },
                accessLevel: accessLevels.rebuses
            })
            .state('appsoup.application.coupons', {
                url: '/coupons',
                controller: 'CouponsController',
                templateUrl: 'views/application/coupons/coupons.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.COUPONS.TITLE'
                },
                accessLevel: accessLevels.coupons
            })
            .state('appsoup.application.coupons_import', {
                url: '/coupons/:couponId/import',
                controller: 'CouponImportController',
                templateUrl: 'views/application/coupons/import.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.COUPONS.IMPORT',
                    parent: 'appsoup.application.coupons'
                },
                accessLevel: accessLevels.coupons
            })
            .state('appsoup.application.coupon_import_shops', {
                url: '/coupons/import/shops/:couponId',
                controller: 'CouponImportShopsController',
                templateUrl: 'views/application/coupons/importShops.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.COUPONS.IMPORT_SHOP.TITLE',
                    parent: 'appsoup.application.coupons'
                },
                accessLevel: accessLevels.coupons
            })
            .state('appsoup.application.coupons_all_import', {
                url: '/coupons/import',
                controller: 'CouponAllImportController',
                templateUrl: 'views/application/coupons/importAll.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.COUPONS.IMPORT',
                    parent: 'appsoup.application.coupons'
                },
                accessLevel: accessLevels.coupons
            })
            .state('appsoup.application.scratch_cards_import', {
                url: '/coupons/import/scratch-cards',
                controller: 'ScratchCardsImportController',
                templateUrl: 'views/application/coupons/importScratchCards.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.COUPONS.IMPORT_SCRATCH_CARDS',
                    parent: 'appsoup.application.coupons'
                },
                accessLevel: accessLevels.coupons
            })
            .state('appsoup.application.logs', {
                url: '/logs',
                controller: 'LogsController',
                templateUrl: 'views/application/logs/logs.tpl.html',
                params: {
                    searchLogs: null
                },
                ncyBreadcrumb: {
                    label: 'MODULES.LOGS.TITLE'
                },
                accessLevel: accessLevels.logs
            })
            .state('appsoup.application.price_lists', {
                url: '/price_lists',
                controller: 'PriceListsController',
                templateUrl: 'views/application/price_lists/price_lists.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.PRICE_LISTS.TITLE'
                },
                accessLevel: accessLevels.price_lists
            })
            .state('appsoup.application.price_lists_import', {
                url: '/import',
                controller: 'PriceListImportController',
                templateUrl: 'views/application/price_lists/import.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.PRICE_LISTS.IMPORT',
                    parent: 'appsoup.application.price_lists'
                },
                accessLevel: accessLevels.price_lists
            })
            .state('appsoup.application.integrations', {
                url: '/integrations',
                controller: 'UserIntegrationController',
                templateUrl: 'views/application/integrations/index.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.INTEGRATIONS.TITLE'
                },
                accessLevel: accessLevels.integrations
            })
            .state('appsoup.application.users_www', {
                url: '/users-www',
                templateUrl: 'views/application/users-www/users.tpl.html',
                controller: 'AppUsersWebListController',
                ncyBreadcrumb: {
                    label: 'MODULES.APPLICATIONS.MODULES.USERS_WWW.TITLES.MAIN'
                },
                accessLevel: accessLevels.users_www
            })
            .state('appsoup.application.wwwUserEdit', {
                url: '/user-www/:userId/edit',
                templateUrl: 'views/application/users-www/user.tpl.html',
                controller: 'AppUserWebController',
                ncyBreadcrumb: {
                    label: 'MODULES.APPLICATIONS.MODULES.USERS_WWW.TITLES.EDIT',
                    parent: 'appsoup.application.users_www'
                },
                menuActive: 'appsoup.application.users_www',
                accessLevel: accessLevels.users_www
            })
            .state('appsoup.application.wwwUserCreate', {
                url: '/user-www/create',
                templateUrl: 'views/application/users-www/user.tpl.html',
                controller: 'AppUserWebController',
                ncyBreadcrumb: {
                    label: 'MODULES.APPLICATIONS.MODULES.USERS_WWW.TITLES.NEW',
                    parent: 'appsoup.application.users_www'
                },
                menuActive: 'appsoup.application.users_www',
                accessLevel: accessLevels.users_www
            })
            .state('appsoup.application.wwwUserImport', {
                url: '/users-www/import',
                controller: 'AppUsersImportController',
                templateUrl: 'views/application/users-www/import.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.APPUSERS-WWW.IMPORT',
                    parent: 'appsoup.application.users_www'
                },
                menuActive: 'appsoup.application.users_www',
                accessLevel: accessLevels.users_www
            })
            .state('appsoup.application.categories', {
                url: '/categories',
                controller: 'CategoryController',
                templateUrl: 'views/application/categories/categories.tpl.html',
                params: {
                    searchCategories: null
                },
                ncyBreadcrumb: {
                    label: 'MODULES.CATEGORIES.TITLE'
                },
                accessLevel: accessLevels.categories
            })
            .state('appsoup.application.categoryCreate', {
                url: '/categories/create',
                controller: 'CreateCategoryController',
                templateUrl: 'views/application/categories/category.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.CATEGORIES.CREATE_CATEGORY',
                    parent: 'appsoup.application.categories'
                },
                menuActive: 'appsoup.application.categories',
                accessLevel: accessLevels.categories
            })
            .state('appsoup.application.editCategory', {
                url: '/categories/edit/:categoryId',
                controller: 'CreateCategoryController',
                templateUrl: 'views/application/categories/category.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.CATEGORIES.EDIT_CATEGORY',
                    parent: 'appsoup.application.categories'
                },
                menuActive: 'appsoup.application.categories',
                accessLevel: accessLevels.categories
            })
            .state('appsoup.application.shopping_lists', {
                url: '/shopping-list',
                controller: 'ShoppingListController',
                templateUrl: 'views/application/shopping_lists/lists.tpl.html',
                params: {
                    searchShoppingLists: null
                },
                ncyBreadcrumb: {
                    label: 'MODULES.SHOPPING_LISTS.TITLE'
                },
                accessLevel: accessLevels.shopping_lists
            })
            .state('appsoup.application.facets', {
                url: '/facets',
                controller: 'FacetsController',
                templateUrl: 'views/application/facets/facets.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.FACETS.TITLE'
                },
                accessLevel: accessLevels.facets
            })
            .state('appsoup.application.newFacet', {
                url: '/facets/new',
                controller: 'FacetController',
                templateUrl: 'views/application/facets/facet.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.FACETS.NEW',
                    parent: 'appsoup.application.facets'
                },
                menuActive: 'appsoup.application.facets',
                accessLevel: accessLevels.facets
            })
            .state('appsoup.application.editFacet', {
                url: '/facets/:facetId/edit',
                controller: 'FacetController',
                templateUrl: 'views/application/facets/facet.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.FACETS.EDIT',
                    parent: 'appsoup.application.facets'
                },
                menuActive: 'appsoup.application.facets',
                accessLevel: accessLevels.facets
            })
            .state('appsoup.application.short_codes', {
                url: '/shortcodes',
                controller: 'ShortCodesController',
                templateUrl: 'views/application/shortcodes/shortCodes.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.SHORT_CODES.TITLE'
                },
                accessLevel: accessLevels.short_codes
            })
            .state('appsoup.application.newShortCode', {
                url: '/shortcodes/new',
                controller: 'ShortCodeController',
                templateUrl: 'views/application/shortcodes/shortCode.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.SHORT_CODES.NEW',
                    parent: 'appsoup.application.short_codes'
                },
                menuActive: 'appsoup.application.short_codes',
                accessLevel: accessLevels.short_codes
            })
            .state('appsoup.application.editShortCode', {
                url: '/shortcodes/:shortCodeId/edit',
                controller: 'ShortCodeController',
                templateUrl: 'views/application/shortcodes/shortCode.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.SHORT_CODES.EDIT',
                    parent: 'appsoup.application.short_codes'
                },
                menuActive: 'appsoup.application.short_codes',
                accessLevel: accessLevels.short_codes
            })
            .state('appsoup.application.themes', {
                url: '/themes/',
                controller: 'ThemesController',
                templateUrl: 'views/application/themes/themes.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.THEMES.TITLE'
                },
                accessLevel: accessLevels.themes
            })
            .state('appsoup.application.newTheme', {
                url: '/theme/new',
                controller: 'ThemeController',
                templateUrl: 'views/application/themes/theme.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.THEMES.NEW',
                    parent: 'appsoup.application.themes'
                },
                menuActive: 'appsoup.application.themes',
                accessLevel: accessLevels.themes
            })
            .state('appsoup.application.editTheme', {
                url: '/theme/:themeId',
                controller: 'ThemeController',
                templateUrl: 'views/application/themes/theme.tpl.html',
                ncyBreadcrumb: {
                    label: 'MODULES.THEMES.EDIT',
                    parent: 'appsoup.application.themes'
                },
                menuActive: 'appsoup.application.themes',
                accessLevel: accessLevels.themes
            });
    }
    ]);
